/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class LockConfigFilter {
    getFixupPrototypeFunction() { return LockConfigFilter.fixupPrototype; }

    static newInstance(model: Partial<LockConfigFilter>): LockConfigFilter {
        let obj = Object.assign(new LockConfigFilter(), model);
        LockConfigFilter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<LockConfigFilter>): LockConfigFilter {
        if (!model) return null;
        return LockConfigFilter.newInstance(<LockConfigFilter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: LockConfigFilter) {
        if (!obj) return;

        models.LockConfigFilter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: LockConfigFilter): boolean {
        Object.setPrototypeOf(obj, LockConfigFilter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Scope of Lock
     */
    lock_scope: models.LockScope;

    lock_types: Array<models.LockType>;

    service_names: Array<models.CloudServiceName>;

    statuses: Array<models.LockStatus>;

    /**
     * Search string
     */
    search: string;

}
